export default __webpack_public_path__ + "media/avslortlogo-XW8XA.svg";